import { APP_MODULES } from "@/data_source/constants";
import type { APIAccessControl } from "@/data_source/models/APIUserMeResponse";

export const NOTIFICATIONS_VIEW_CAPABILITY = "notifications.view";
export const NOTIFICATIONS_MARK_READ_CAPABILITY = "notifications.mark_read";
export type NotificationBootstrapStatus =
  | "disconnected"
  | "waiting"
  | "connected"
  | "permission-denied"
  | "error";

function includesCanonicalValue(
  values: string[] | undefined,
  expected: string
): boolean {
  const normalizedExpected = expected.trim().toLowerCase();
  return Boolean(
    values?.some((value) => value.trim().toLowerCase() === normalizedExpected)
  );
}

/**
 * Notification feeds and Firebase are shell-level background consumers. They
 * must start only when `/api/users/me` grants both the public capability and
 * its effective module. Missing access-control data is intentionally denied.
 */
export function canBootstrapNotifications(
  accessControl: APIAccessControl | null | undefined
): boolean {
  return (
    includesCanonicalValue(
      accessControl?.capabilities,
      NOTIFICATIONS_VIEW_CAPABILITY
    ) &&
    includesCanonicalValue(
      accessControl?.effective_modules,
      APP_MODULES.MESSAGE_MODULE
    )
  );
}

export function canMarkNotificationsRead(
  accessControl: APIAccessControl | null | undefined
): boolean {
  return (
    canBootstrapNotifications(accessControl) &&
    includesCanonicalValue(
      accessControl?.capabilities,
      NOTIFICATIONS_MARK_READ_CAPABILITY
    )
  );
}

export function shouldShowNotificationPermissionWarning(
  enabled: boolean,
  status: NotificationBootstrapStatus
): boolean {
  return enabled && status === "permission-denied";
}
